<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" alt="logo"></a>
                    <p style="margin-top:-10px">
                        Fondazione Ampioraggio nasce nel 2016 a Salerno con l’obiettivo di creare un ecosistema nazionale di innovazione, unendo Nord e Sud Italia
                    </p>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/FondazioneAmpioraggio/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.facebook.com/groups/299305673498674/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.linkedin.com/groups/3960255/" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        <li><a href="https://www.youtube.com/channel/UCCe88x-cjdEBhlnEYmbAYbw" class="d-block" target="_blank"><i class='bx bxl-youtube'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Link</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li class="d-none"><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Login</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Discenti</a></li>
                        <li><a href="https://discentya.fondazioneampioraggio.academy/login.php" target="_blank">Docenti</a></li>
                        <li><a href="https://discentya.fondazioneampioraggio.academy/login.php" target="_blank">Partners</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Dove Siamo</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Corso Vittorio Emanuele II, 123<br>84014 Nocera Inferiore (SA)</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+393758232271">Telefono: (+39) 375-8232271</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:segreteria@fondazioneampioraggio.it">segreteria@fondazioneampioraggio.it</a></li>
                        <li class="d-none"><i class='bx bxs-inbox'></i><a href="tel:+557854578964">Lunedì-Venerdì: 9:00 – 13:00 / 14:00 – 19:00<br>Sabato: 9:00 - 13:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2025 Fondazione Ampioraggio - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a href="https://www.consorform.it/privacy/" target="_blank">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
